/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2024-11-21 21:06:08
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React from "react";
import Big from "big.js";
import { BsyUtils } from "../../utils/Utils";
import BsyTextEditor from "../BsyTextEditor";
import "./index.css";
import { BsyConfig } from "../../global/BsyConfig";
import { getAfterSuffix } from "../../utils/getAfterSuffix";

export default class BsyNumber extends BsyTextEditor {
  constructor(props) {
    super({
      allowDecimals: !0,
      allowNegative: !0,
      maxNumber: null,
      minNumber: null,
      value: "",
      step: 0.5,
      notround: false,
      displayMode: "number", //格式模式
      precision: null, //nuu 关闭小数位模式 最多保留4位
      thousandsSeparator: false, //千分符
      inputTag: "input",
      afterSuffix: {
        zh_cn: "",
        en_us: "",
        zh_tw: "",
      },  // 单位
      ...props,
    });

    let a = this.options;
    let b1 = "[-]?[\\d]{0,}[\\.]?[\\d]{0,}";
    // a.allowDecimals && (b1 = "[-]?[\\d]{0,}[\\.]?[\\d]{0,}");
    // a.allowNegative && (b1 = "[-]?" + b1);
    a.regex = "^" + b1 + "$";

    this.handleChange = this.handleChange.bind(this);
  }

  _init = () => {
    this.setValue(this.options.value);
  };

  handleChange(event) {
    this.value = event.target.value;
    this.setState({ value: event.target.value });
  }

  _getFormat = () => {
    var a = this.options;
    return BsyUtils.numberFormatStr(a);
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    let c = this.options;
    let v = BsyUtils.toNumberString(this.value);
    if (nextProps.value !== v) {
      var val = BsyUtils.toNumberString(nextProps.value);
      if (c.displayMode == "percent") {
        if (val) val = new Big(val).times(100).toFixed();
      }
      this.formatValue(val);
    }
  }

  onBlur = (e) => {
    this.hasFocus = false;
    let that = this;
    e.target.classList.remove("x-input-focus");
    this.value = e.target.value;
    this.checkValidate();
    this.formatValue(this.value, () => {
      BsyUtils.applyFunc(
        that,
        that.options.onStopEdit,
        [that.getValue(), null, this],
        !1
      );
    });
  };

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.getValue(), null, this],
        !1
      );
    }
  }

  formatValue = (val, cb) => {
    let a = this.options;

    var value = null;

    if (val) {
      if (
        BsyUtils.isString(val) &&
        (val.hasOwnProperty("replace") || val.indexOf(",") > -1)
      )
        val = val.replace(/,/g, "");
    }
    value = val;

    var tmp = parseFloat(value);
    value = BsyUtils.parseNumber(value);
    if (isNaN(tmp)) {
      value = null;
    } else {
      if (a.displayMode == "percent") {
        value = new Big(value).div(100).toFixed();
      }
    }
    this.value = BsyUtils.formatValue(value, a);
    var format = this._getFormat();
    let text = BsyUtils.num2Str(this.value, format);
    if (a.displayMode === "number") {
      this.setState(
        {
          value: text, //.replace('%', '').replace(/,/g, '')
        },
        () => {
          cb && cb();
        }
      );
    } else {
      this.setState(
        {
          value: text.replace("%", "").replace(/,/g, ""),
        },
        () => {
          cb && cb();
        }
      );
    }
  };

  checkValidate = () => {
    let a = this.options,
      c = !0;
    var b = BsyUtils.toNumberString(this.value);
    if (BsyUtils.isEmpty(b)) {
      c = a.allowBlank;
      if (!c) {
        this.setInvalidateTypeText(React.language("item.required"));
      }
    } else if (!BsyUtils.isEmpty(a.regex)) {
      try {
        let d1t = b + "";
        c = new RegExp(a.regex).test(d1t);
      } catch (error) {
        console.log(error);
        c = !1;
      }
      if (!c) {
        // c || this.setInvalidateType("regex")
        this.value = null;
        b = "";
        this.setState({
          value: null,
        });
        c = true;
      } else {
        if (
          (!BsyUtils.isNull(a.maxNumber) && b > a.maxNumber) ||
          (!BsyUtils.isNull(a.minNumber) && b < a.minNumber)
        ) {
          c = false;

          if (!BsyUtils.isNull(a.maxNumber) && !BsyUtils.isNull(a.minNumber)) {
            this.setInvalidateTypeText(
              React.language("widget.number.error.range3", {
                n: a.minNumber,
                n1: a.maxNumber,
              })
            );
          } else if (!BsyUtils.isNull(a.maxNumber)) {
            this.setInvalidateTypeText(
              React.language("widget.number.error.range1", { n: a.maxNumber })
            );
          } else if (!BsyUtils.isNull(a.minNumber)) {
            this.setInvalidateTypeText(
              React.language("widget.number.error.range2", { n: a.minNumber })
            );
          }
        } else {
          this.setInvalidateTypeText("");
          c = true;
        }

        // i && (!FX.Utils.isNull(t.maxNumber) && e > t.maxNumber || !FX.Utils.isNull(t.minNumber) && e < t.minNumber) && (i = !1,
        //   this.setInvalidType(5))
      }
    }
    return (
      c
        ? BsyUtils.applyFunc(this, a.onValidateSuccess, [b], !1) === !1 &&
        this.setTextState(BsyConfig().States.NORMAL)
        : BsyUtils.applyFunc(this, a.onValidateFail, [b], !1) === !1 &&
        this.setTextState(BsyConfig().States.ERROR),
      BsyUtils.applyFunc(this, a.onAfterValidate, [b, c], !1),
      c
    );
  };

  setValue = (a) => {
    let b = this;
    let c = this.options;

    if (BsyUtils.ISNULL(a)) {
      b.value = null;
    } else {
      b.value = a;
    }
    var val = BsyUtils.toNumberString(b.value);
    if (c.displayMode == "percent") {
      if (val) val = new Big(val).times(100).toFixed();
    }
    this.formatValue(val);

    // BsyUtils.applyFunc(b, c.onStickyStopEdit, [], !1);
  };

  getValue = () => {
    if (BsyUtils.isEmpty(this.value)) return null;
    let b = BsyUtils.fixDecimalPrecision(this.value);
    return isNaN(b) ? null : b;
  };

  getText = () => {
    var t = this.getValue();
    t = BsyUtils.toNumberString(t);
    return t ? t.replace(/,/g, "") : "";
  };

  onKeyUp = (e) => {
    let a = this.options;
    let b = this;
    if (b.isEnabled()) {
      this.value = e.target.value;
      this.checkValidate();
      BsyUtils.applyFunc(b, a.onAfterEdit, [b.getValue(), null, this], !1);
      BsyUtils.applyFunc(b, a.onKeyUp, [e, this.value], !1);

      if (e.keyCode === 13 || e.which === 13) {
        this.formatValue(this.value, () => {
          BsyUtils.applyFunc(
            b,
            b.options.onStopEdit,
            [b.getValue(), null, this],
            !1
          );
        });
      }
    }
  };

  renderDisablePane = (value) => {
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
      >
        {value}
      </div>
    );
  };

  onFocus = (e) => {
    // x-input-focus
    e.target.classList.add("x-input-focus");
    let a = this.options;
    this.hasFocus = true;
    //编辑状态 显示原始值
    if (a.displayMode == "number") {
      this.value = BsyUtils.toNumberString(this.value);
      this.setState({
        value: this.value,
      });
    }

    this.lastValue = this.value;
  };




  render() {
    const {
      cssName,
      inputCls,
      widgetName,
      displayMode,
      css,
      waterMark,
      hint,
      format,
      inputTag,
      afterSuffix,
    } = this.options;
    const { value } = this.state;
    // var str = this.getStrValue();
    const afterSuffixVal = getAfterSuffix(afterSuffix)
    if (!this.isEnabled()) {
      let text = "";
      if (format) {
        text = BsyUtils.numberFormatValue(this.value, { format: format }).text;

        if (!format.includes("%")) {
          text = text + (text && afterSuffixVal ? ` ${afterSuffixVal}` : "");
        }

      } else {
        if (displayMode === "number" || !displayMode) {
          // var format = this._getFormat();
          text = value + (value && afterSuffixVal ? ` ${afterSuffixVal}` : "");
        } else {
          text = value + (value ? "%" : "");
        }
      }
      return this.renderDisablePane(text);
    }

    return (
      <div className={`${cssName} ${afterSuffixVal ? "after-suffix-show" : ""}`} style={css} ref={this.element}>
        <div className="text-context" style={{ display: "flex", width: "100%" }}>
          {inputTag == "textarea" ? (
            <textarea
              className={inputCls}
              style={{
                minHeight: css.height,
                width: "100%",
                resize: "none",
              }}
              ref={this.input}
              widgetname={widgetName}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={this.handleChange}
              onKeyDown={this.onkeyDown}
              onKeyUp={this.onKeyUp}
              placeholder={waterMark || hint ? waterMark || hint : ""}
              // defaultValue={value === null ? "" : value}
              value={value === null ? "" : value}
            ></textarea>
          ) : (
            <input
              type="text"
              className={inputCls}
              style={{
                height: css.height,
              }}
              ref={this.input}
              widgetname={widgetName}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onChange={this.handleChange}
              onKeyDown={this.onkeyDown}
              onKeyUp={this.onKeyUp}
              // defaultValue={value === null ? "" : value}
              value={value === null ? "" : value}
              placeholder={waterMark || hint ? waterMark || hint : ""}
            />
          )}

          {displayMode === "percent" ? (
            <div className="percent">
              <div className="percent-value">
                {value ? (value + "").replace("%", "") : ""}
              </div>
              <div
                className="percent-suffix"
                style={{
                  height: css.height - 2 + "xp",
                  lineHeight: css.height - 2 + "px",
                }}
              >
                {value ? "%" : ""}
              </div>
            </div>
          ) : afterSuffixVal ? (
            <div className="after-suffix">
              {afterSuffixVal}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
